import { Constants } from "@eagerdog/constants";

import { IEventRegisterRow } from "src/services/helper.service.js";

import { ShowTypes } from "@eagerdog/constants";
import { IOption } from "../../Dropdown/Dropdown";

export namespace AKCAgility {
  const show = ShowTypes[Constants.sanctioning_club.AKC][Constants.show_type.agility];

  const getInputs = (): IEventRegisterRow[] => {
    const standardOrJWWOrFast = [
      {
        value: Constants.dog_class_element_level.novice_a,
        id: Constants.dog_class_element_level.novice_a,
      },
      {
        value: Constants.dog_class_element_level.novice_b,
        id: Constants.dog_class_element_level.novice_b,
      },
      {
        value: Constants.dog_class_element_level.novice_preferred,
        id: Constants.dog_class_element_level.novice_preferred,
      },
      {
        value: Constants.dog_class_element_level.akc_open,
        id: Constants.dog_class_element_level.akc_open,
      },
      {
        value: Constants.dog_class_element_level.open_preferred,
        id: Constants.dog_class_element_level.open_preferred,
      },
      {
        value: Constants.dog_class_element_level.excellent,
        id: Constants.dog_class_element_level.excellent,
      },
      {
        value: Constants.dog_class_element_level.excellent_preferred,
        id: Constants.dog_class_element_level.excellent_preferred,
      },
      {
        value: Constants.dog_class_element_level.master,
        id: Constants.dog_class_element_level.master,
      },
      {
        value: Constants.dog_class_element_level.master_preferred,
        id: Constants.dog_class_element_level.master_preferred,
      },
    ]

    const getOptionsByElement = (element: string): IOption[] => {
      switch (element) {
        case Constants.dog_class_element.standard:
        case Constants.dog_class_element.jumpers_with_weaves:
        case Constants.dog_class_element.fast:
          return standardOrJWWOrFast;
        case Constants.dog_class_element.t2b:
          return [
            {
              value: Constants.dog_class_element_level.t2b,
              id: Constants.dog_class_element_level.t2b,
            },
            {
              value: Constants.dog_class_element_level.t2b_preferred,
              id: Constants.dog_class_element_level.t2b_preferred,
            },
          ];
        case Constants.dog_class_element.premier_standard:
          return [
            {
              value: Constants.dog_class_element_level.premier_standard,
              id: Constants.dog_class_element_level.premier_standard,
            },
            {
              value: Constants.dog_class_element_level.premier_standard_preferred,
              id: Constants.dog_class_element_level.premier_standard_preferred,
            },
          ];
        case Constants.dog_class_element.premier_jww:
          return [
            {
              value: Constants.dog_class_element_level.premier_jww,
              id: Constants.dog_class_element_level.premier_jww,
            },
            {
              value: Constants.dog_class_element_level.premier_jww_preferred,
              id: Constants.dog_class_element_level.premier_jww_preferred,
            },
          ];
        default:
          return [];
      }
    }

    return Object.keys(show).map((element: string) => {
      return {
        allowDuplicates: false,
        inputs: [
          {
            type: "checkbox",
            label: element,
            multiSelect: false,
            options: getOptionsByElement(element),
          },
        ],
      }
    })
  }

  export const form: IEventRegisterRow[] = getInputs();
}
